/* eslint-disable */
import { Box, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import BreachDetails from './BreachDetails'
import StatusAndList from './StatusAndList'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      style={{
        height: '100%',
      }}
      {...other}
    >
      {children}
    </div>
  )
}

export default function BreachTabs({ breachDetails, setNeedUpdate }: any) {
  if (!breachDetails || !breachDetails?.breachInfo) return null
  const { breachInfo } = breachDetails
  const { id } = breachInfo
  const [tabValue, setTabValue] = useState(0)

  return (
    <Box
      sx={{
        width: '100%',
        mt: 2,
        border: '2px solid gray',
        borderRadius: '6px',
        height: 'calc(100% - 84px - 170px)',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          variant='scrollable'
          scrollButtons='auto'
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 'normal',
              color: '#5B5B5B',
              '&.Mui-selected': {
                color: '#1976d2',
                fontWeight: 'bold',
              },
            },
          }}
        >
          <Tab label='Breach Details' />
          <Tab label='Investigation' />
          <Tab label='Containment' />
          <Tab label='Remediation' />
          <Tab label='Report to Authorities' />
          <Tab label='Report to Affected Organizations' />
          <Tab label='Notification to Affected Clients' />
          <Tab label='Additional Actions' />
        </Tabs>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          padding: '0px 10px 10px 10px',
        }}
      >
        <TabPanel value={tabValue} index={0}>
          <div
            style={{
              height: '100%',
              boxSizing: 'border-box',
            }}
          >
            <BreachDetails breachDetails={breachDetails} />
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 1 && (
              <StatusAndList phase='investigation' breachId={id} breachInfo={breachInfo} setNeedUpdate={setNeedUpdate} />
            )}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 2 && (
              <StatusAndList
                phase='containment'
                breachId={id}
                breachInfo={breachInfo}
                setNeedUpdate={setNeedUpdate}
              />
            )}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 3 && (
              <StatusAndList
                phase='remediation'
                breachId={id}
                breachInfo={breachInfo}
                setNeedUpdate={setNeedUpdate}
              />
            )}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} index={4}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 4 && (
              <StatusAndList
                phase='report_to_authorities'
                breachId={id}
                breachInfo={breachInfo}
                setNeedUpdate={setNeedUpdate}
              />
            )}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} index={5}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 5 && (
              <StatusAndList
                phase='report_to_affected_organizations'
                breachId={id}
                breachInfo={breachInfo}
                setNeedUpdate={setNeedUpdate}
              />
            )}
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={6}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 6 && (
              <StatusAndList
                phase='notification_to_affected_clients'
                breachId={id}
                breachInfo={breachInfo}
                setNeedUpdate={setNeedUpdate}
              />
            )}
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={7}>
          <div style={{ boxSizing: 'border-box', height: '100%' }}>
            {tabValue === 7 && (
              <StatusAndList
                phase='additional_actions'
                breachId={id}
                breachInfo={breachInfo}
                setNeedUpdate={setNeedUpdate}
              />
            )}
          </div>
        </TabPanel>
      </Box>
    </Box>
  )
}
